import { Spinner, Stack } from '@chakra-ui/react';
import { Editor } from '@tinymce/tinymce-react';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { securedAxiosInstance } from '../api/axios';
import Card from '../components/Card';
import '../theme/css/tinymceStyles.css';

const TINYMCE_API = process.env.REACT_APP_TINYMCE_KEY;

const SharedJournal = () => {
  const { reference } = useParams();
  const navigate = useNavigate();
  const [journal, setJournal] = useState({ entry: null });

  const editorRef = useRef(null);
  useEffect(() => {
    const getJournal = async () => {
      const res = await securedAxiosInstance.get(
        `/journals/public/${reference}`
      );
      if (!res.data) {
        return navigate('/shared_journal/404');
      }

      setJournal(res.data);
      return;
    };

    getJournal();
  }, [reference]);

  useEffect(() => {
    if (editorRef.current && journal.entry) {
      editorRef.current.setContent(journal.entry);
      editorRef.current.undoManager.clear();
    }
  }, [journal.entry, editorRef]);

  return (
    <Stack spacing={8} mx={'auto'} maxW={'6xl'} w={'100%'} py={12} px={6}>
      <Card>
        {journal && journal.entry ? (
          <Editor
            apiKey={TINYMCE_API}
            onInit={(evt, editor) => {
              editorRef.current = editor;
              editor.setContent(journal ? journal.entry : '');
              editor.undoManager.clear();
            }}
            disabled={true}
            initialValue={journal.entry}
            init={{
              readonly: true,
              height: '100%',
              menubar: false,
              branding: false,
              toolbar: false,
              statusbar: false,
              plugins: 'autoresize',

              content_style:
                'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            }}
          />
        ) : (
          <Spinner color="primary" />
        )}
      </Card>
    </Stack>
  );
};

export default SharedJournal;
